import { classNames } from '@allurion/ui';
import { useIntl } from 'react-intl';
import ReactSelect from 'react-select';

import colors from 'src/styles/theme/colors';

import styles from './AllurionSelect.module.scss';

const definedStyles = {
  option: (styles: any, { isFocused, isSelected }: any) => {
    const allStyles = {
      ...styles,
    };

    if (isSelected) {
      return {
        ...allStyles,
        backgroundColor: colors.GreyBorder,
        color: '#000',
      };
    }
    if (isFocused) {
      return {
        ...allStyles,
        backgroundColor: 'rgba(0,0,0,0.1)',
      };
    }

    return {
      ...allStyles,
      backgroundColor: 'transparent',
    };
  },
};

type Props = {
  [key: string]: any;
  options: any[];
  defaultValue?: any;
  selectStyles?: any;
  className?: string;
};

export function AllurionSelect({
  options,
  defaultValue,
  selectStyles = {},
  className,
  ...props
}: Props) {
  const intl = useIntl();

  return (
    <ReactSelect
      defaultValue={defaultValue}
      options={options}
      classNamePrefix="react-select"
      styles={{ ...definedStyles, ...selectStyles }}
      className={classNames(styles['custom-select'], className)}
      noOptionsMessage={() =>
        intl.formatMessage({ id: 'allurion-select.no-options', defaultMessage: 'No options' })
      }
      placeholder={intl.formatMessage({
        id: 'allurion-select.placeholder',
        defaultMessage: 'Select...',
      })}
      {...props}
    />
  );
}
